import React from "react";
import hero from "../img/hero.jpg";
import Model from "@tripian/model";
import { SvgIcons } from "@tripian/react";

type Props = {
  onClickGetStarted: () => void;
  t: (value: Model.TranslationKey) => string;
};

const YourPersonalTripPlanner: React.FC<Props> = ({ onClickGetStarted, t }) => {
  return (
    <div className="relative w-full h-[1021px] md:h-[900px] -translate-y-[5%] md:translate-y-0">
      <img
        src={hero}
        alt="Lakeside beach with kayaks at sunset"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-black bg-opacity-40" />
      <div className="relative z-10 flex flex-col justify-center h-full px-8 md:px-16 text-start max-w-3xl">
        <h1 className="text-4xl md:text-[4.375rem]/[5.3125rem] font-montserrat font-bold text-zinc-50 mb-10 md:mb-6 leading-snug tracking-wide">
          {t("landing.canadaStrong.title")}
        </h1>
        <p className="text-zinc-50 text-2xl/[2.5rem] font-normal mb-16 md:mb-8">
          {t("landing.canadaStrong.description")}
        </p>
        <button
          className="flex items-center space-x-3 rtl:space-x-reverse bg-primary-color text-white font-semibold rounded-full transition duration-200 size-fit px-10 py-5 w-fit"
          onClick={onClickGetStarted}
        >
          <span className="text-base md:text-xl">
            {t("landing.canadaStrong.startPlanningForFree")}
          </span>
          <SvgIcons.ArrowRight2 size="1.5rem" />
        </button>
      </div>
    </div>
  );
};

export default YourPersonalTripPlanner;
